export function orderedSets(cards, pet, sort) {
 const list=cards.filter(card=>pet==='all'||card.dataset.pet===pet);
 const compare=sort==='price-low'?(a,b)=>Number(a.dataset.price)-Number(b.dataset.price):sort==='price-high'?(a,b)=>Number(b.dataset.price)-Number(a.dataset.price):sort==='az'?(a,b)=>a.dataset.name.localeCompare(b.dataset.name):(a,b)=>Number(a.dataset.order)-Number(b.dataset.order);
 return list.sort(compare);
}
if(!customElements.get('pawture-sets-collection')){
 customElements.define('pawture-sets-collection',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();
   this.grid=this.querySelector('[data-sets-grid]');
   this.cards=[...this.querySelectorAll('[data-set-card]')];
   const url=new URL(location.href);
   this.pet=['cat','dog'].includes(url.searchParams.get('pet'))?url.searchParams.get('pet'):'all';
   this.sort=this.querySelector('[data-sets-sort]');
   if(['featured','price-low','price-high','az'].includes(url.searchParams.get('sort')))this.sort.value=url.searchParams.get('sort');
   this.addEventListener('click',event=>{
    const button=event.target.closest('[data-pet-entry],[data-sets-filter]');
    if(!button||!this.contains(button))return;
    this.pet=button.dataset.petEntry||button.dataset.setsFilter;
    this.render(true);
    if(button.hasAttribute('data-pet-entry'))this.querySelector('.pw-sets-catalog').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
   },{signal:this.abort.signal});
   this.sort.addEventListener('change',()=>this.render(true),{signal:this.abort.signal});
   this.render(false);
  }
  disconnectedCallback(){this.abort?.abort();}
  render(updateUrl){
   const cards=orderedSets(this.cards,this.pet,this.sort.value);
   const included=new Set(cards);
   this.cards.forEach(card=>card.hidden=!included.has(card));
   this.grid.append(...cards);
   this.querySelectorAll('[data-sets-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.setsFilter===this.pet)));
   this.querySelectorAll('[data-pet-entry]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.petEntry===this.pet)));
   this.querySelector('[data-sets-heading]').textContent=this.dataset[this.pet+'Title'];
   this.querySelector('[data-sets-count]').textContent=this.dataset.countLabel.replace('[count]',cards.length);
   this.querySelector('[data-sets-empty]').hidden=cards.length>0;
   if(updateUrl){const url=new URL(location.href);if(this.pet==='all')url.searchParams.delete('pet');else url.searchParams.set('pet',this.pet);if(this.sort.value==='featured')url.searchParams.delete('sort');else url.searchParams.set('sort',this.sort.value);history.replaceState(null,'',url.pathname+url.search+url.hash);}
  }
 });
}

